// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1vjMt","name":"Header_name__3ffg_","birthday":"Header_birthday__1QhMU","skeleton":"Header_skeleton__1dRrS"};